import { render, staticRenderFns } from "./answerMsgDialog.vue?vue&type=template&id=65a197d8&scoped=true&"
import script from "./answerMsgDialog.vue?vue&type=script&lang=js&"
export * from "./answerMsgDialog.vue?vue&type=script&lang=js&"
import style0 from "./answerMsgDialog.vue?vue&type=style&index=0&id=65a197d8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a197d8",
  null
  
)

export default component.exports